/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolAnnotations,
  ToolAnnotations$inboundSchema,
} from "./toolannotations.js";

/**
 * The type of tool
 */
export const ToolEntryType = {
  Http: "http",
  Prompt: "prompt",
  Function: "function",
  Platform: "platform",
  Externalmcp: "externalmcp",
} as const;
/**
 * The type of tool
 */
export type ToolEntryType = OpenEnum<typeof ToolEntryType>;

export type ToolEntry = {
  /**
   * Tool annotations providing behavioral hints about the tool
   */
  annotations?: ToolAnnotations | undefined;
  /**
   * HTTP method for HTTP tools (GET, POST, PUT, PATCH, DELETE)
   */
  httpMethod?: string | undefined;
  /**
   * The ID of the tool
   */
  id: string;
  /**
   * The name of the tool
   */
  name: string;
  /**
   * The URN of the tool
   */
  toolUrn: string;
  /**
   * The type of tool
   */
  type: ToolEntryType;
};

/** @internal */
export const ToolEntryType$inboundSchema: z.ZodMiniType<
  ToolEntryType,
  unknown
> = openEnums.inboundSchema(ToolEntryType);

/** @internal */
export const ToolEntry$inboundSchema: z.ZodMiniType<ToolEntry, unknown> = z
  .pipe(
    z.object({
      annotations: z.optional(ToolAnnotations$inboundSchema),
      http_method: z.optional(z.string()),
      id: z.string(),
      name: z.string(),
      tool_urn: z.string(),
      type: ToolEntryType$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "http_method": "httpMethod",
        "tool_urn": "toolUrn",
      });
    }),
  );

export function toolEntryFromJSON(
  jsonString: string,
): SafeParseResult<ToolEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolEntry' from JSON`,
  );
}
